module.exports = __webpack_public_path__ + "static/media/loader.a0ccfef4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.svg
// module id = 1095
// module chunks = 0